import { render, staticRenderFns } from "./ShipmentItem.vue?vue&type=template&id=dbc488c2&scoped=true"
import script from "./ShipmentItem.vue?vue&type=script&lang=js"
export * from "./ShipmentItem.vue?vue&type=script&lang=js"
import style0 from "./ShipmentItem.vue?vue&type=style&index=0&id=dbc488c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc488c2",
  null
  
)

export default component.exports